import { Box, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

interface PageIntroProps {
    heading: string
    paragraphs: string[]
}

const PageIntro: React.FC<PageIntroProps> = ({ heading, paragraphs }) => {
    return (
        <Box sx={{ mb: 3 }}>
            {heading && (
                <Typography
                    component="h1"
                    variant="h5"
                    sx={{ fontWeight: 700, fontSize: { xs: '1.1rem', md: '1.4rem' }, mb: 1.5 }}
                >
                    {heading}
                </Typography>
            )}
            {paragraphs.map((para, i) => (
                <RichText key={i} html={para} variant="body2" color="text.secondary" sx={{ mb: 1 }} />
            ))}
        </Box>
    )
}

export default PageIntro
export type { PageIntroProps }
